export const ALBUMS_SEED = [
  {
    id: "freewheelin-1963",
    title: "The Freewheelin’ Bob Dylan",
    year: 1963,
    cover:
      "https://images.unsplash.com/photo-1511379938547-c1f69419868d?q=80&w=800&auto=format&fit=crop",
    songs: [
      { id: "blowin-wind", title: "Blowin’ in the Wind", track: 1 },
      { id: "girl-north", title: "Girl from the North Country", track: 2 },
    ],
  },
  {
    id: "bringing-1965",
    title: "Bringing It All Back Home",
    year: 1965,
    cover:
      "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=800&auto=format&fit=crop",
    songs: [
      { id: "mr-tambourine", title: "Mr. Tambourine Man", track: 7 },
      {
        id: "its-alright-ma",
        title: "It’s Alright, Ma (I’m Only Bleeding)",
        track: 8,
      },
    ],
  },
  {
    id: "blonde-1966",
    title: "Blonde on Blonde",
    year: 1966,
    cover:
      "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=800&auto=format&fit=crop",
    songs: [
      { id: "visions-johanna", title: "Visions of Johanna", track: 4 },
      { id: "just-like-woman", title: "Just Like a Woman", track: 9 },
    ],
  },
];
